import { render, staticRenderFns } from "./ruleDetail.vue?vue&type=template&id=4fe6b5da"
import script from "./ruleDetail.vue?vue&type=script&lang=js"
export * from "./ruleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports